import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { ProductDescriptionParsedField } from './ProductDescriptionParsedField'

export const ProductDescriptionResponsiblePersonEu: FC<{
  responsiblePersonEU: string
}> = ({ responsiblePersonEU }) => {
  return (
    <>
      <h3 className="mt-5 text-s font-medium">
        <FormattedMessage id="general.label.responsiblePersonEU" />
      </h3>
      <ProductDescriptionParsedField
        className="not-prose"
        field={responsiblePersonEU}
      />
    </>
  )
}
